



















import { Component, Vue } from 'vue-property-decorator'
import BaseDropdown from '@/components/reusable-components/controls/BaseDropdown.vue'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import TranslationModule from '@/utils/TranslationModule'
import HeaderCommunityNavigation from '@/components/layout/header/navigation/HeaderCommunityNavigation.vue'
import HeaderEventNavigation from '@/components/layout/header/navigation/HeaderEventNavigation.vue'
import HeaderResourceNavigation from '@/components/layout/header/navigation/HeaderResourceNavigation.vue'
import HeaderMoreNavigation from '@/components/layout/header/navigation/HeaderMoreNavigation.vue'
import HeaderInvestmentNavigation from '@/components/layout/header/navigation/HeaderInvestmentNavigation.vue'

@Component({
    components: { BaseButton, BaseDropdown },
})
export default class HeaderNavigation extends Vue {
    get navigationItems() {
        return [
            {
                label: this.$trans('header.menu.item.community', TranslationModule.COMMON),
                dropdownComponent: HeaderCommunityNavigation,
            },
            {
                label: this.$trans('header.menu.item.events', TranslationModule.COMMON),
                dropdownComponent: HeaderEventNavigation,
            },
            {
                label: this.$trans('header.menu.item.resources', TranslationModule.COMMON),
                dropdownComponent: HeaderResourceNavigation,
            },
            {
                label: this.$trans('header.menu.item.investment', TranslationModule.COMMON),
                dropdownComponent: HeaderInvestmentNavigation,
            },
            {
                label: this.$trans('header.menu.item.more', TranslationModule.COMMON),
                dropdownComponent: HeaderMoreNavigation,
            },
        ]
    }
}
